import React from 'react'
import CloseIcon from '@material-ui/icons/ClearRounded'
import styled from '@emotion/styled'

const StyledCloseIcon = styled(CloseIcon)`
  margin: 0 25px;
  font-size: 18px;
  color: #9ea0a5;

  &:hover {
    cursor: pointer;
  }
`

type Props = {
  onClick: () => void
}

const CloseXIcon = (props: Props) => <StyledCloseIcon {...props} />

export default CloseXIcon
